import { React, useState } from "react";
import { Box } from "@mui/system";
import { headersPost } from "../../Services/API";
import { ApiUrls } from "../../Services/Routes/API";
import { MainRoutes } from "../../Services/Routes/App";
import SuccessIcon from "../../Svg/SuccessIcon";
import FormModal from "../FormModal";
import OtherBillIcon from "../../Svg/OtherBillIcon";
import AceIcon from "../../Svg/AceIcon";
import DataIcon from "../../Svg/DataIcon";
import CableIcon from "../../Svg/CableIcon";
import AirTimeIcon from "../../Svg/DataIcon";
import UtilityIcon from "../../Svg/UtilityIcon";
import { Typography, Paper, Button, Icon } from "@mui/material";
import SuccessCard from "../../components/SuccessCard";
import {
  FormValidations,
  AirtimeValidations,
  DataValidations,
  CableValidations,
  BillsValidations,
  BetValidations,
} from "../../Services/validation/modalValidation/index";
import { useNavigate } from "react-router-dom";
import { ModalSpinner } from "../../Svg";
import { NETWORK_PROVIDER_ENUMS } from "../../Services/Enums";
import LoadCard from "../LoadCard";

// ----------------------------------------------------------------------------------------------------

export default function SlideList({ cards = [] }) {
  //Hooks for Modals
  const [openModal, setOpenModal] = useState(false);
  const [SuccessModalOpen, setSuccessModalOpen] = useState(false); //Modal For Success Card
  const [start, setstart] = useState(false);
  const [pin, setpin] = useState(false);
  const [shuru, setshuru] = useState(false);
  const [pick, setpick] = useState(false);
  const [tip, settip] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [open, setOpen] = useState(false);
  const [alertIcon, setAlertIcon] = useState("error");
  const [LoaderText, setLoaderText] = useState("Transaction Processing");
  const [LoaderIcon, setLoaderIcon] = useState(<ModalSpinner />);
  const [resStatus, setResStatus] = useState("");

  let resourcevariable;
  const navigate = useNavigate();

  const closeModals = () => {
    setOpenModal(false);
    setstart(false);
    setpin(false);
    setshuru(false);
    setpick(false);
    settip(false);
    setSuccessModalOpen(false);
  };

  //Arrays For Modal Values

  const option_for_choose_wallet = cards?.map((card) => {
    return { name: card?.name, value: card?.id };
  });

  //{Betting} Modals Array
  const Form_Modal_List_For_USSD = [
    {
      formKey: "payment",
      name: "wallet_id",
      label: "Choose Wallet",
      type: "select",
      options: option_for_choose_wallet,
    },
    {
      formKey: "payment",
      name: "service_provider",
      label: "Service Provider",
      type: "select",
      options: NETWORK_PROVIDER_ENUMS,
    },
    {
      formKey: "payment",
      name: "package",
      label: "Select Packages",
      type: "select",
      options: NETWORK_PROVIDER_ENUMS,
    },
    {
      formKey: "payment",
      name: "customer_id",
      label: "Customer ID",
    },
    {
      formKey: "payment",
      name: "amount",
      label: "Amount",
    },
  ];

  //{Utillity Bills} Modal Array
  const Form_Modal_List_For_Bills = [
    {
      formKey: "payment",
      name: "wallet_id",
      label: "Choose Wallet",
      type: "select",
      options: option_for_choose_wallet,
    },
    {
      formKey: "payment",
      name: "service_provider",
      label: "Choose Utillty Company",
      type: "select",
      options: NETWORK_PROVIDER_ENUMS,
    },
    {
      formKey: "payment",
      name: "package",
      label: "Select Packages",
      type: "select",
      options: NETWORK_PROVIDER_ENUMS,
    },
    {
      formKey: "payment",
      name: "customer_id",
      label: "Meter Number",
    },
    {
      formKey: "payment",
      name: "amount",
      label: "Amount",
    },
  ];

  //Cable Modal Array
  const Form_Modal_List_For_CAN = [
    {
      formKey: "payment",
      name: "wallet_id",
      label: "Choose Wallet",
      type: "select",
      options: option_for_choose_wallet,
    },
    {
      formKey: "payment",
      name: "service_provider",
      label: "Choose Utillty Company",
      type: "select",
      options: NETWORK_PROVIDER_ENUMS,
    },
    {
      formKey: "payment",
      name: "package",
      label: "Select Packages",
      type: "select",
      options: NETWORK_PROVIDER_ENUMS,
    },
    {
      formKey: "payment",
      name: "decoder_number",
      label: "Smart Card/ Decoder Number",
    },
    {
      formKey: "payment",
      name: "amount",
      label: "Amount",
    },
  ];

  //AirTime Modal Array
  const Form_Modal_List_For_UK = [
    {
      formKey: "payment",
      name: "wallet_id",
      label: "Choose Wallet",
      type: "select",
      options: option_for_choose_wallet,
    },
    {
      formKey: "payment",
      name: "network_provider",
      label: "Network Provider",
      type: "select",
      options: NETWORK_PROVIDER_ENUMS,
    },

    {
      formKey: "payment",
      name: "phone_number",
      label: "Phone Number",
    },
    {
      formKey: "payment",
      name: "amount",
      label: "Amount",
    },
  ];

  //{Data},{Other Bill Payment} Modals
  const Form_Modal_List_For_PK = [
    {
      formKey: "payment",
      name: "wallet_id",
      label: "Choose Wallet",
      type: "select",
      options: option_for_choose_wallet,
    },
    {
      formKey: "payment",
      name: "network_provider",
      label: "Network Provider",
      type: "select",
      options: NETWORK_PROVIDER_ENUMS,
    },
    {
      formKey: "payment",
      name: "packages",
      label: "Select Packages",
      type: "select",
      options: NETWORK_PROVIDER_ENUMS,
    },
    {
      formKey: "payment",
      name: "phone_number",
      label: "Phone Number",
    },
    {
      formKey: "payment",
      name: "amount",
      label: "Amount",
    },
  ];

  //Buttons for SideModals
  const Form_Modal_List_For_BUTTONS_USSD_FIRST = [
    {
      text: "Back",
      name: "back",
      width: 90,
      handler: () => {},
      // bgcolor: theme?.palette?.primary?.dark,
    },
    {
      text: "Next",
      name: "next",
      type: "submit",
      width: 150,
      handler: () => {},
    },
  ];

  const Form_Modal_List_For_BUTTONS_USSD_sec = [
    {
      text: "Back",
      name: "back_button",
      type: "back",
      width: 90,
      handler: () => {
        alert("alert of back button");
      },
      // bgcolor: theme?.palette?.primary?.dark,
    },
    {
      text: "Confirm",
      name: "confirm",
      type: "submit",
      width: 150,
      handler: () => {},
    },
  ];

  //Password Field for All Modals
  const Form_Modal_List_Via_Bank_Account = [
    {
      name: "pass",
      label: "Transaction Password",
      type: "password",
    },
  ];

  // ------------------------------------------------------------------------------------------------
  const submitHandlerSideModals = (data) => {
    debugger;
    setOpen(true);
    headersPost(ApiUrls?.SideList_DATA, data)
      .then((res) => {
        setOpen(false);
        if (res?.status === 200 && res?.data?.success) {
          setOpenModal(false);
          setstart(false);
          setpin(false);
          setshuru(false);
          setpick(false);
          settip(false);
          setAlertMsg(res?.data?.message);
          setAlertIcon("success");
          setSuccessModalOpen(true);
          // setLoaderIcon(<SuccessIcon />);
          // setModalSuccessState(true);
          resourcevariable = res?.status;
          // setAlertOpen(true);
          setResStatus(res?.status);
          setLoaderText("Wallet Funding");
          // modalCloseforAll();
          // setFundWalletModal(false);
        } else {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        setOpen(false);
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(MainRoutes?.root);
        } else {
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
        }
      });
  };

  return (
    <>
      <Box sx={{ marginTop: "10px" }}>
        <Typography
          variant="h6"
          sx={{
            color: "#00008B",
            fontFamily: "Inter",
            fontSize: "18px",
            fontWeight: "bold",
            fontStyle: "normal",
          }}
        >
          Bills Payment
        </Typography>
        <Box>
          {/* Betting Modal */}
          <Paper
            component={Button}
            onClick={() => setOpenModal(true)}
            sx={{
              display: "flex",
              width: "100%",
              justifyContent: "flex-start",
              marginTop: "5px",
            }}
          >
            <Typography sx={{ display: "flex", justifyContent: "space" }}>
              <Icon sx={{ lineHeight: 0.5, marginRight: "12px" }}>
                <AceIcon />{" "}
              </Icon>
              Betting
            </Typography>
          </Paper>

          {/* Utility Bills Modal */}
          <Paper
            component={Button}
            onClick={() => setstart(true)}
            sx={{
              display: "flex",
              width: "100%",
              justifyContent: "flex-start",
              marginTop: "5px",
            }}
          >
            <Typography sx={{ display: "flex", justifyContent: "space" }}>
              <Icon sx={{ lineHeight: 0.5, marginRight: "12px" }}>
                <UtilityIcon />
              </Icon>
              Utility Bills
            </Typography>
          </Paper>

          {/* Cable Modal */}
          <Paper
            component={Button}
            onClick={() => setpin(true)}
            sx={{
              display: "flex",
              width: "100%",
              justifyContent: "flex-start",
              marginTop: "5px",
            }}
          >
            <Typography sx={{ display: "flex", justifyContent: "space" }}>
              <Icon sx={{ lineHeight: 0.5, marginRight: "12px" }}>
                <CableIcon />
              </Icon>
              Cable
            </Typography>
          </Paper>

          {/* AirTime Modal */}
          <Paper
            component={Button}
            onClick={() => setshuru(true)}
            sx={{
              display: "flex",
              width: "100%",
              justifyContent: "flex-start",
              marginTop: "5px",
            }}
          >
            <Typography sx={{ display: "flex", justifyContent: "space" }}>
              <Icon sx={{ lineHeight: 0.5, marginRight: "12px" }}>
                <AirTimeIcon />
              </Icon>
              AirTime
            </Typography>
          </Paper>

          {/* Data Modal */}
          <Paper
            component={Button}
            onClick={() => setpick(true)}
            sx={{
              display: "flex",
              width: "100%",
              justifyContent: "flex-start",
              marginTop: "5px",
            }}
          >
            <Typography sx={{ display: "flex", justifyContent: "space" }}>
              <Icon sx={{ lineHeight: 0.5, marginRight: "12px" }}>
                <DataIcon />
              </Icon>
              Data
            </Typography>
          </Paper>

          {/* Other Bills Modal */}
          <Paper
            component={Button}
            onClick={() => settip(true)}
            sx={{
              display: "flex",
              width: "100%",
              justifyContent: "flex-start",
              marginTop: "5px",
            }}
          >
            <Typography sx={{ display: "flex", justifyContent: "space" }}>
              <Icon sx={{ lineHeight: 0.5, marginRight: "12px" }}>
                <OtherBillIcon />
              </Icon>
              Other Bill Payments
            </Typography>
          </Paper>
        </Box>
      </Box>

      {/*------------------Assigning Values to Modals------------------*/}

      {/*  LoadCard Modal */}
      <LoadCard open={open} />
      <SuccessCard
        title={"Bet Payment"}
        msg={alertMsg}
        open={SuccessModalOpen}
        onClose={closeModals}
        action={() => {
          // setOpenModal(true);
          setSuccessModalOpen(false);
        }}
      />

      {/* Betting Modal */}
      <FormModal
        MainHeading={"Betting"}
        SubHeading={""}
        modalPages={2}
        TextFieldArray={Form_Modal_List_For_USSD}
        ButtonsArray={Form_Modal_List_For_BUTTONS_USSD_FIRST}
        open={openModal}
        onClose={closeModals}
        //Second Page
        SecondMainHeading={"Enter Your 4-digit Password"}
        SecondSimpleText={"Kindly Enter your Transaction Password to proceed"}
        TextFieldArraySecond={Form_Modal_List_Via_Bank_Account}
        ButtonsArraySecond={Form_Modal_List_For_BUTTONS_USSD_sec}
        ValidationSchemaModals={BetValidations}
        initialFormData={{
          payment: {
            billing_type: "betting",
          },
        }}
        onSubmit={submitHandlerSideModals}
      />

      {/* Utillity Bills Modal */}

      <FormModal
        MainHeading={"Pay Utillity Bills"}
        SubHeading={""}
        modalPages={2}
        TextFieldArray={Form_Modal_List_For_Bills}
        ButtonsArray={Form_Modal_List_For_BUTTONS_USSD_FIRST}
        open={start}
        onClose={closeModals}
        //Second Page
        SecondMainHeading={"Enter Your 4-digit Password"}
        SecondSimpleText={"Kindly Enter your Transaction Password to proceed"}
        TextFieldArraySecond={Form_Modal_List_Via_Bank_Account}
        ButtonsArraySecond={Form_Modal_List_For_BUTTONS_USSD_sec}
        ValidationSchemaModals={BillsValidations}
        initialFormData={{
          payment: {
            billing_type: "utility_bill",
          },
        }}
        onSubmit={submitHandlerSideModals}
      />

      {/* Cable Modal */}

      <FormModal
        MainHeading={"Card Subscription"}
        SubHeading={""}
        modalPages={2}
        TextFieldArray={Form_Modal_List_For_CAN}
        ButtonsArray={Form_Modal_List_For_BUTTONS_USSD_FIRST}
        open={pin}
        onClose={closeModals}
        //Second Page
        SecondMainHeading={"Enter Your 4-digit Password"}
        SecondSimpleText={"Kindly Enter your Transaction Password to proceed"}
        TextFieldArraySecond={Form_Modal_List_Via_Bank_Account}
        ButtonsArraySecond={Form_Modal_List_For_BUTTONS_USSD_sec}
        ValidationSchemaModals={CableValidations}
        initialFormData={{
          payment: {
            billing_type: "cable",
          },
        }}
        onSubmit={submitHandlerSideModals}
      />

      {/* AirTime Modal */}

      <FormModal
        MainHeading={"AirTime Purchase"}
        SubHeading={""}
        modalPages={2}
        TextFieldArray={Form_Modal_List_For_UK}
        ButtonsArray={Form_Modal_List_For_BUTTONS_USSD_FIRST}
        open={shuru}
        onClose={closeModals}
        //Second Page
        SecondMainHeading={"Enter Your 4-digit Password"}
        SecondSimpleText={"Kindly Enter your Transaction Password to proceed"}
        TextFieldArraySecond={Form_Modal_List_Via_Bank_Account}
        ButtonsArraySecond={Form_Modal_List_For_BUTTONS_USSD_sec}
        ValidationSchemaModals={AirtimeValidations}
        initialFormData={{
          payment: {
            billing_type: "airtime",
          },
        }}
        onSubmit={submitHandlerSideModals}
      />

      {/* Data Modal */}

      <FormModal
        MainHeading={"Mobile Data Purchase"}
        SubHeading={""}
        modalPages={2}
        TextFieldArray={Form_Modal_List_For_PK}
        ButtonsArray={Form_Modal_List_For_BUTTONS_USSD_FIRST}
        open={pick}
        onClose={closeModals}
        //Second Page
        SecondMainHeading={"Enter Your 4-digit Password"}
        SecondSimpleText={"Kindly Enter your Transaction Password to proceed"}
        TextFieldArraySecond={Form_Modal_List_Via_Bank_Account}
        ButtonsArraySecond={Form_Modal_List_For_BUTTONS_USSD_sec}
        ValidationSchemaModals={DataValidations}
        initialFormData={{
          payment: {
            billing_type: "data",
          },
        }}
        onSubmit={submitHandlerSideModals}
      />

      {/* Other Bills Modal */}
      <FormModal
        MainHeading={"Mobile Data Purchase"}
        SubHeading={""}
        modalPages={2}
        TextFieldArray={Form_Modal_List_For_PK}
        ButtonsArray={Form_Modal_List_For_BUTTONS_USSD_FIRST}
        open={tip}
        onClose={closeModals}
        //Second Page
        SecondMainHeading={"Enter Your 4-digit Password"}
        SecondSimpleText={"Kindly Enter your Transaction Password to proceed"}
        TextFieldArraySecond={Form_Modal_List_Via_Bank_Account}
        ButtonsArraySecond={Form_Modal_List_For_BUTTONS_USSD_sec}
        ValidationSchemaModals={DataValidations}
        initialFormData={{
          payment: {
            billing_type: "other_bills_payment",
          },
        }}
        onSubmit={submitHandlerSideModals}
      />

      {/* ----------------------------------------------------------------- */}
    </>
  );
}
